import { IModalManager, __experimental_promisifyModalHandle as promisifyModalHandle } from '@cp/shared/modal';
import { LOGIN_MODAL } from '../lib';

export const loginModalHandle = (manager: IModalManager) => promisifyModalHandle(LOGIN_MODAL, manager);
